define('sections/referrals/Podio.UI.Referrals.Teaser',['require','translate','jquery','lib/Podio.UI.Tasks.Create','lib/Podio.Transport','lib/Podio.UI.Modal','lib/Podio.Routes','lib/Podio.Event.UI','lib/Podio.Statsd','lib/Podio.Utils','lib/Podio.Config'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  var TaskCreate = require('lib/Podio.UI.Tasks.Create');
  var Transport = require('lib/Podio.Transport');
  var Modal = require('lib/Podio.UI.Modal');
  var routes = require('lib/Podio.Routes');
  var eventUI = require('lib/Podio.Event.UI');

  var podioStatsd = require('lib/Podio.Statsd');
  var podioUtils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');

  var helpers = {
    switchToThanksMode : function _switchToThanksMode() {
      var elmThanksSection = $('#referral_teaser_content .thanks-section');
      elmThanksSection.removeClass('hidden');

      var elmCloseButton = $('.modal .content.referral-teaser .footer .close-button');
      if (elmCloseButton.length) {
        elmCloseButton.text(t('Done #referrals'));
        elmCloseButton.removeClass('secondary');
        elmCloseButton.addClass('primary');
      }
    },

    persistModalDismissal : function _persistModalDismissal(status) {
      Transport.putJSON(routes.update_teaser_status_referrals_path(), { requestData: {'status': status} });
    }
  };

  function showModal() {
    Transport.getJSON(routes.new_referral_path(), {}, function(responseData) {
      Modal.show(responseData.data.html, {
        title: t('Share Podio #referrals'),
        className: 'referral-teaser',
        hideHandler: onModalClosed
      });

      podioStatsd.increment('sharepodio.modal-old.view');
    });
  }

  function onShareLinkClicked(elmTarget, e) {
    var elmInput = $('<input type="text" />');
    var textElmExists = elmTarget.find('.text').length;
    var inputElmAlreadyExists = elmTarget.find('input').length;

    elmInput.val(elmTarget.text());

    if (textElmExists && !inputElmAlreadyExists) {
      elmInput.css({ width: elmTarget.width() - 42 });
      elmTarget.find('.text').html(elmInput);
    } else if (!elmTarget.find('input').length) {
      elmTarget.html(elmInput);
    }

    elmInput.select();
    helpers.switchToThanksMode();
  }

  function onShareButtonClicked(elmTarget, e) {
    helpers.switchToThanksMode();
  }

  function onCloseButtonClicked(elmTarget, e) {
    Modal.hide();
  }

  function onModalClosed() {
    helpers.persistModalDismissal('sidebar');
    podioStatsd.increment('sharepodio.modal-old.close');
    return true;
  }

  function onAssignTaskClicked(elmTarget, e) {
    helpers.persistModalDismissal('sidebar');

    TaskCreate.newModal({
      attributes: {
        space_id: null,
        text: t('Help others to work like me, share Podio #referrals'),
        due_date: elmTarget.data('due-date'),
        description: t('Refer others to Podio so they can work smarter, using the referral page: #referrals') + ' ' + elmTarget.attr('href')
      }
    });
  }

  function onWidgetClosed(elmTarget, e) {
    helpers.persistModalDismissal('disabled');
    var elmWidget = elmTarget.parents('#referrals_widget:first');
    elmWidget.fadeOut();
  }

  eventUI.bind('click', '#referral_teaser_content .share-url .link, #referrals_widget .share-url .link, .button-copy-link', onShareLinkClicked);
  eventUI.bind('click', '#referral_teaser_content a.button-new', onShareButtonClicked, true);
  eventUI.bind('click', '.modal .content.referral-teaser .footer .close-button', onCloseButtonClicked);
  eventUI.bind('click', '.modal .content.referral-teaser .footer .assign-task', onAssignTaskClicked);
  eventUI.bind('click', '#referrals_widget a.close', onWidgetClosed);

  return {
    show: showModal
  };

});

